import { motion } from 'framer-motion';
import { useState } from 'react';

const categories = ['All', 'Logos', 'Social Media', 'Posters', 'Thumbnails', 'Web Graphics'];

const portfolioItems = [
  {
    id: 1,
    title: 'Modern Tech Startup Logo',
    category: 'Logos',
    image: 'https://public.readdy.ai/ai/img_res/4178657845ba851ab81e9c36476248c6.jpg',
  },
  {
    id: 2,
    title: 'Instagram Branding Pack',
    category: 'Social Media',
    image: 'https://readdy.ai/api/search-image?query=elegant%20instagram%20social%20media%20post%20template%20design%20with%20modern%20layout%20clean%20typography%20and%20professional%20aesthetic%20on%20light%20neutral%20background&width=600&height=600&seq=2&orientation=squarish',
  },
  {
    id: 3,
    title: 'Gaming YouTube Thumbnail',
    category: 'Thumbnails',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20gaming%20youtube%20thumbnail%20design%20with%20bold%20typography%20vibrant%20colors%20and%20energetic%20composition%20on%20dark%20background%20professional%20quality&width=600&height=400&seq=3&orientation=landscape',
  },
  {
    id: 4,
    title: 'Event Promotion Flyer',
    category: 'Posters',
    image: 'https://readdy.ai/api/search-image?query=elegant%20event%20promotion%20poster%20design%20with%20modern%20layout%20clean%20typography%20and%20professional%20aesthetic%20on%20light%20background%20premium%20quality&width=600&height=800&seq=4&orientation=portrait',
  },
  {
    id: 5,
    title: 'E-commerce Website Graphics',
    category: 'Web Graphics',
    image: 'https://readdy.ai/api/search-image?query=modern%20e-commerce%20website%20banner%20design%20with%20clean%20layout%20professional%20product%20showcase%20and%20elegant%20typography%20on%20light%20neutral%20background&width=800&height=500&seq=5&orientation=landscape',
  },
  {
    id: 6,
    title: 'Luxury Brand Identity',
    category: 'Logos',
    image: 'https://readdy.ai/api/search-image?query=luxury%20premium%20brand%20logo%20design%20with%20elegant%20typography%20sophisticated%20style%20and%20refined%20aesthetic%20on%20clean%20white%20background%20professional%20identity&width=600&height=600&seq=6&orientation=squarish',
  },
  {
    id: 7,
    title: 'Facebook Ad Campaign',
    category: 'Social Media',
    image: 'https://readdy.ai/api/search-image?query=professional%20facebook%20advertisement%20design%20with%20compelling%20visuals%20clean%20layout%20and%20modern%20typography%20on%20light%20background%20marketing%20campaign&width=600&height=600&seq=7&orientation=squarish',
  },
  {
    id: 8,
    title: 'Music Album Cover',
    category: 'Posters',
    image: 'https://readdy.ai/api/search-image?query=artistic%20music%20album%20cover%20design%20with%20creative%20composition%20bold%20typography%20and%20modern%20aesthetic%20on%20dark%20background%20professional%20quality&width=600&height=600&seq=8&orientation=squarish',
  },
];

export default function LuxuryPortfolioSection() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredItems = activeCategory === 'All' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <section id="portfolio" className="relative py-24 bg-gradient-to-b from-deepBlue to-charcoal overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
            Featured <span className="gradient-text">Portfolio</span>
          </h2>
          <p className="text-white/70 text-lg font-body max-w-2xl mx-auto mb-8">
            A showcase of premium design work across various categories
          </p>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-2 rounded-full font-cta font-medium text-sm smooth-transition cursor-pointer whitespace-nowrap ${
                  activeCategory === category
                    ? 'glass-panel glow-gold-cta text-white shimmer-cta'
                    : 'glass-panel text-white/70 hover:text-white hover-lift'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: index * 0.1 }}
              className="glass-panel rounded-2xl overflow-hidden glow-gold smooth-transition hover-lift cursor-pointer group"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover smooth-transition group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/20 to-transparent opacity-0 group-hover:opacity-100 smooth-transition flex items-end p-6">
                  <div>
                    <div className="text-xs font-cta text-gold mb-1">{item.category}</div>
                    <h3 className="text-lg font-display font-bold text-white">{item.title}</h3>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
